import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Reveal, SectionHead } from "./Reveal";

const inputCls = "w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm outline-none focus:border-amber-500 focus:ring-2 focus:ring-amber-500/20 transition";

export default function EnquirySection() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/enquiries", form);
      toast.success("Enquiry mil gayi! Team jaldi contact karegi.");
      setForm({ name: "", phone: "", email: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section id="enquiry" className="py-24 bg-cream">
      <div className="mx-auto grid max-w-7xl items-start gap-12 px-5 sm:px-8 lg:grid-cols-2">
        <div>
          <SectionHead
            index="06" label="Enquiries"
            title="Custom notes chahiye? Bulk order? Ya koi doubt?"
            sub="Form bharein — aapki enquiry seedha owner ke admin panel me pahunchegi. Coaching centers aur schools ke bulk orders bhi welcome hain."
          />
          <Reveal delay={0.15}>
            <div className="mt-8 space-y-4">
              {["PDF customisation apne school/board ke hisaab se", "Bulk pricing coaching institutes ke liye", "Naye notes ya courses ki request"].map((t) => (
                <div key={t} className="flex items-start gap-3 rounded-2xl border border-slate-200 bg-white p-4">
                  <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-amber-500" />
                  <p className="text-sm font-medium text-slate-700">{t}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <form onSubmit={submit} className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8" data-testid="enquiry-form">
            <div className="space-y-4">
              <input required value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="Aapka naam" data-testid="enquiry-name-input" className={inputCls} />
              <input value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="Phone / WhatsApp number" data-testid="enquiry-phone-input" className={inputCls} />
              <input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="Email (optional)" data-testid="enquiry-email-input" className={inputCls} />
              <textarea value={form.message} onChange={(e) => set("message", e.target.value)} placeholder="Kya chahiye? Class, subject, quantity…" data-testid="enquiry-message-input" className={`${inputCls} min-h-28`} />
            </div>
            <button type="submit" disabled={busy} data-testid="enquiry-submit-btn"
              className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-ink py-3.5 font-display font-bold text-amber-400 hover:bg-ink2 disabled:opacity-60">
              {busy ? <Loader2 size={16} className="animate-spin" /> : <Send size={15} />} Enquiry Bhejein
            </button>
            <p className="mt-3 text-center text-[11px] text-slate-400">Naam + phone ya email — kuch bhi ek zaroori hai.</p>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
